import {createStore} from "effector";

export const $showPopup = createStore(false)

export const $showMenu = createStore(false)

export const $postPopup = createStore(false)
